/**
 * It takes a query object and returns the page number of the table
 */
export const tablePageCalc = queryObject => (Number(queryObject.skip) + Number(queryObject.take))/ Number(queryObject.take);